"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _field;
  return (0, _styles.createStyles)({
    root: {
      display: 'inline-flex',
      background: theme.palette.NEUTRAL000
    },
    disabled: {
      background: 'transparent'
    },
    input: {
      opacity: 0,
      margin: 0,
      borderRadius: 0,
      '-webkit-appearance': 'none'
    },
    field: (_field = {
      display: 'flex',
      cursor: 'pointer',
      position: 'relative',
      boxSizing: 'content-box',
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(4),
      transitionProperty: 'all',
      transitionDuration: '200ms',
      transitionTimingFunction: 'ease',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      userSelect: 'none',
      borderRadius: 4,
      borderWidth: 1,
      borderStyle: 'solid',
      borderImage: 'initial',
      borderColor: theme.palette.NEUTRAL060
    }, _defineProperty(_field, theme.breakpoints.down('md'), {
      paddingLeft: theme.spacing(3),
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      flexDirection: 'row',
      justifyContent: 'flex-start'
    }), _defineProperty(_field, '&:hover', {
      borderColor: theme.palette.BLUE400
    }), _field),
    fieldSelected: {
      borderColor: theme.palette.BLUE400,
      '&::before': {
        borderColor: theme.palette.BLUE400
      }
    },
    fieldDisabled: {
      cursor: 'not-allowed',
      borderColor: theme.palette.NEUTRAL050,
      '&:hover': {
        borderColor: theme.palette.NEUTRAL050
      }
    },
    fieldHorizontal: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
      padding: theme.spacing(1.75, 2.5)
    },
    hideCheck: {
      visibility: 'hidden'
    },
    iconChecked: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.palette.BLUE400,
      minWidth: 24,
      width: 24,
      height: 24,
      position: 'absolute',
      left: 'auto',
      top: 16,
      right: 16,
      boxSizing: 'border-box',
      borderRadius: '50%'
    },
    iconCheckedHorizontal: {
      position: 'static',
      marginRight: theme.spacing(2.5)
    },
    iconUnchecked: {
      backgroundColor: theme.palette.NEUTRAL010,
      borderWidth: 2,
      borderStyle: 'solid',
      borderRadius: '50%',
      borderColor: theme.palette.NEUTRAL040
    },
    iconCheckedDisabled: {
      backgroundColor: theme.palette.NEUTRAL050,
      borderColor: theme.palette.NEUTRAL050
    },
    iconUncheckedDisabled: {
      backgroundColor: 'transparent',
      borderColor: theme.palette.NEUTRAL050
    },
    innerField: {
      position: 'relative',
      display: 'inline-block'
    },
    picture: _defineProperty({
      fontSize: theme.typography.pxToRem(100)
    }, theme.breakpoints.down('md'), {
      fontSize: theme.typography.pxToRem(70)
    }),
    pictureDimmed: {
      opacity: 0.7
    },
    pictureSelected: {
      opacity: 1
    },
    pictureHorizontal: {
      fontSize: theme.typography.pxToRem(25)
    },
    textWrapper: _defineProperty({
      display: 'block',
      position: 'relative',
      marginTop: theme.spacing(4),
      whiteSpace: 'pre-wrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    }, theme.breakpoints.down('md'), {
      marginTop: theme.spacing(0),
      paddingLeft: theme.spacing(3)
    }),
    textWrapperHorizontal: {
      marginLeft: theme.spacing(1),
      marginTop: 0
    },
    text: {
      display: 'inline-block',
      color: theme.palette.NEUTRAL200,
      fontSize: theme.typography.pxToRem(16),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: theme.typography.pxToRem(24)
    },
    textHorizontal: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(22)
    },
    textSelected: {
      color: theme.palette.BLUE400
    },
    textDisabled: {
      color: theme.palette.NEUTRAL100
    },
    fullWidth: {
      width: '100%'
    }
  });
});
var _default = useStyles;
exports.default = _default;